import format from 'date-fns/format';
import { config } from '@uhg-abyss/web/tools/config';
import pdfLogo from '@src/app/App/Content/Confirmation/print/pdf_logo.png';

const setCheckBoxStyles = (select, value) => {
  for (let i = 1; i <= 6; i++) {
    const element = document.getElementById(
      `attestation${select}-checkbox-${i}-span`
    );
    if (element) {
      element.style.transition = value;
    }
  }
};
const createHeader = () => {
  const date = document.createElement('div');
  date.textContent = format(new Date(), 'MM/dd/yyyy');
  date.setAttribute(
    'style',
    'color:#002677;font-size:18px;font-weight:bold;margin-top:3px;'
  );
  const title = document.createElement('div');
  title.textContent = 'Tin Registration';
  title.setAttribute(
    'style',
    'text-align:center;width:100%;color:#002677;font-size:20px;font-weight:bold;margin-top:3px;margin-left:135px'
  );

  const header = document.createElement('div');
  header.setAttribute(
    'style',
    'display:flex;font-size:10px;margin-bottom:62px'
  );
  header.appendChild(title);
  header.appendChild(date);

  return header;
};

let html2pdf;
if (typeof window !== 'undefined') {
  html2pdf = require('html2pdf.js');
}

export const print = {
  printPage: () => {
    if (typeof window !== 'undefined') {
      window.print();
    }
  },

  savePDF: (element, npiInfo, fileName, callback) => {
    if (!html2pdf) {
      if (callback) callback();
      return; // Prevent SSR crash
    }

    const style = 'all 0.2s ease 0s';
    const none = 'none';
    const header = createHeader();
    const pdfWrapper = document.createElement('div');
    pdfWrapper.setAttribute('style', 'margin:0 10px');
    pdfWrapper.appendChild(header);

    const statusBanner = document.getElementById('successful-confirmation');
    const w9Upload = document.getElementById('w9upload-confirmation');
    const practiceData = document.getElementById('practice-data-confirmation');
    const locationsData = document.getElementById('locations-confirmation');
    const attestationData = document.getElementById(
      'attestation-data-confirmation'
    );

    // Add null checks for required elements
    if (
      !statusBanner ||
      !w9Upload ||
      !practiceData ||
      !locationsData ||
      !attestationData
    ) {
      if (callback) callback();
      return;
    }

    setCheckBoxStyles('-data', none);

    if (element) {
      pdfWrapper.appendChild(statusBanner.cloneNode(true));
      pdfWrapper.appendChild(w9Upload.cloneNode(true));
      pdfWrapper.appendChild(practiceData.cloneNode(true));
      pdfWrapper.appendChild(locationsData.cloneNode(true));
      pdfWrapper.appendChild(attestationData.cloneNode(true));
    }

    const styleElement = document.createElement('style');
    styleElement.textContent = `
      * {
        box-shadow: none !important;
      }
      [class*="header"], [class*="Header"], header, .abyss-card-title, [class*="abyss-card-title"], h3 {
        background-color: #E5E5E6 !important;
        padding: 10px !important;
        color: #323334;
      }
      [class*="abyss-card-section"] {
        padding: 12px 24px 12px 24px !important;
      }
      [class*="abyss-checkbox-label"] {
        margin-left: 10px !important;
      }
      [class*="abyss-card-root"] {
        border-color: #d1d5db !important;
      }
        [class*="abyss-alert-container"] {
        border-color: #007000;
        background-color: #f2f8e6 !important;
      }
      [class*="abyss-alert-icon"] {
        color: #007000;
      }
      [class*="abyss-alert-header-text-container"] {
      margin: 0;
    `;
    pdfWrapper.insertBefore(styleElement, pdfWrapper.firstChild);
    const opt = {
      margin: [2, 0],
      filename: `${fileName}.pdf`,
      pagebreak: { mode: ['avoid-all', 'css', 'legacy'] },
    };

    html2pdf()
      .from(pdfWrapper)
      .set(opt)
      .toPdf()
      .get('pdf')
      .then(async (pdf) => {
        pdf.setPage(1);
        try {
          // Get the correct image source
          const imgSrc =
            typeof pdfLogo === 'string'
              ? pdfLogo
              : pdfLogo?.src || pdfLogo?.default;

          if (imgSrc) {
            // Fetch image and convert to data URL to avoid CORS issues
            let response;
            if (config('APP_ENV') === 'local') {
              response = await fetch(imgSrc);
            } else {
              response = await fetch(`${config('PUBLIC_IMAGE')}${imgSrc}`);
            }

            const blob = await response.blob();
            const dataUrl = await new Promise((resolve) => {
              const reader = new FileReader();
              reader.onloadend = () => {
                return resolve(reader.result);
              };
              reader.readAsDataURL(blob);
            });
            pdf.addImage(dataUrl, 'PNG', 3, 4, 54, 17);
          }
        } catch (error) {
          console.error('Error adding logo to PDF:', error);
        }
        return pdf;
      })
      .save()
      .then(() => {
        setCheckBoxStyles('-data', style);
        if (callback) callback();
      })
      .catch((error) => {
        setCheckBoxStyles('-data', style);
        if (callback) callback();
      });
  },

  savePDFReview: (element, info, fileName, callback) => {
    if (!html2pdf) {
      if (callback) callback();
      return; // SSR guard
    }

    const attest = 'attest-inputs';
    const locations = 'locations-edit';
    const practice = 'practice-edit';
    const w9 = 'w9-edit';
    const style = 'all 0.2s ease 0s';
    const none = 'none';
    const header = createHeader();
    const pdfWrapper = document.createElement('div');
    pdfWrapper.setAttribute('style', 'margin:0 10px');
    pdfWrapper.appendChild(header);

    const w9Upload = document.getElementById('w9upload-review');
    const practiceData = document.getElementById('practice-data-review');
    const locationsData = document.getElementById('locations-review');

    if (!w9Upload || !practiceData || !locationsData) {
      if (callback) callback();
      return;
    }

    const attestInputs = document.getElementById(attest);
    const locationsEdit = document.getElementById(locations);
    const practiceEdit = document.getElementById(practice);
    const w9Edit = document.getElementById(w9);

    if (!attestInputs || !locationsEdit || !practiceEdit || !w9Edit) {
      if (callback) callback();
      return;
    }

    const backup = attestInputs.style.display;
    const backupLoc = locationsEdit.style.display;
    const backupPrac = practiceEdit.style.display;
    const backupW9 = w9Edit.style.display;

    attestInputs.style.display = none;
    locationsEdit.style.display = none;
    practiceEdit.style.display = none;
    w9Edit.style.display = none;
    const attestationData = document.getElementById('attestation-data-review');

    if (!attestationData) {
      if (callback) callback();
      return;
    }

    setCheckBoxStyles('', none);

    if (element) {
      pdfWrapper.appendChild(w9Upload.cloneNode(true));
      pdfWrapper.appendChild(practiceData.cloneNode(true));
      pdfWrapper.appendChild(locationsData.cloneNode(true));
      pdfWrapper.appendChild(attestationData.cloneNode(true));
    }
    if (info) {
      pdfWrapper.appendChild(info);
    }

    const styleElement = document.createElement('style');
    styleElement.textContent = `
      * {
        box-shadow: none !important;
      }
      [class*="header"], [class*="Header"], header, .abyss-card-title, [class*="abyss-card-title"], h3 {
        background-color: #E5E5E6 !important;
        padding: 10px !important;
        color: #323334;
      }
      [class*="abyss-card-section"] {
        padding: 12px 24px 12px 24px !important;
      }
      [class*="abyss-checkbox-label"] {
        margin-left: 10px !important;
      }
      [class*="attestation-section"] {
        border-color: #d1d5db !important;
      }
    }
    `;
    pdfWrapper.insertBefore(styleElement, pdfWrapper.firstChild);

    const opt = {
      margin: [2, 0],
      filename: `${fileName}.pdf`,
      pagebreak: { mode: ['avoid-all', 'css', 'legacy'] },
    };

    html2pdf()
      .from(pdfWrapper)
      .set(opt)
      .toPdf()
      .get('pdf')
      .then(async (pdf) => {
        pdf.setPage(1);
        try {
          // Get the correct image source
          const imgSrc =
            typeof pdfLogo === 'string'
              ? pdfLogo
              : pdfLogo?.src || pdfLogo?.default;

          if (imgSrc) {
            // Fetch image and convert to data URL to avoid CORS issues
            let response;
            if (config('APP_ENV') === 'local') {
              response = await fetch(imgSrc);
            } else {
              response = await fetch(`${config('PUBLIC_IMAGE')}${imgSrc}`);
            }

            const blob = await response.blob();
            const dataUrl = await new Promise((resolve) => {
              const reader = new FileReader();
              reader.onloadend = () => {
                return resolve(reader.result);
              };
              reader.readAsDataURL(blob);
            });
            pdf.addImage(dataUrl, 'PNG', 3, 4, 54, 17);
          }
        } catch (error) {
          console.error('Error adding logo to PDF:', error);
        }
        return pdf;
      })
      .save()
      .then(() => {
        attestInputs.style.display = backup;
        locationsEdit.style.display = backupLoc;
        practiceEdit.style.display = backupPrac;
        w9Edit.style.display = backupW9;
        setCheckBoxStyles('', style);
        if (callback) callback();
      })
      .catch((error) => {
        attestInputs.style.display = backup;
        locationsEdit.style.display = backupLoc;
        practiceEdit.style.display = backupPrac;
        w9Edit.style.display = backupW9;
        setCheckBoxStyles('', style);
        if (callback) callback();
      });
  },
};
